import { createAction } from '@reduxjs/toolkit';
import { SET_NOTIFICATIONS_LIST } from '../actionConstants';

export const setNotificationsListAction = createAction(SET_NOTIFICATIONS_LIST);
